import { IconUploadOutline } from '@icons/IconUploadOutline'
import { IconArrowDownOutline } from '@icons/IconArrowDownOutline'
import { IconDocumentFileOutline } from '@icons/IconDocumentFileOutline'
import { FileInput, FileUploader, FileUploaderContent, FileUploaderItem } from '@/components/shadcn/file-uploader'
import clsx from 'clsx'
import { DropzoneOptions } from 'react-dropzone'

type TimelineFileUploaderProps = {
  files: File[]
  selectFiles: (files: File[] | null) => void
  dragging: boolean
  dropZoneConfig: DropzoneOptions
}

export function TimelineFileUploader({ files, selectFiles, dragging, dropZoneConfig }: TimelineFileUploaderProps) {
  return (
    <FileUploader
      value={files}
      onValueChange={selectFiles}
      dropzoneOptions={dropZoneConfig}
      className="relative space-y-1"
    >
      <FileInput
        className={clsx('border border-dashed border-gray-500', {
          'border-solid border-primary bg-primary/10': dragging,
          hidden: files.length > 0,
        })}
      >
        <div className="flex w-full flex-col items-center justify-center gap-y-5 pb-4 pt-3">
          <IconUploadOutline className={clsx('size-7 text-muted', { hidden: dragging })} />
          <IconArrowDownOutline className={clsx('size-7 text-primary', { hidden: !dragging })} />
          <p className="text-sm">{dragging ? 'Drop file' : 'Click to select or drag and drop file'}</p>
        </div>
      </FileInput>
      <FileUploaderContent>
        {files.map((file, i) => (
          <FileUploaderItem key={i} index={i}>
            <div className="flex items-center gap-x-2">
              <IconDocumentFileOutline className="mr-1 inline-block size-4" />
              <span className="max-w-md truncate font-light italic text-primary">{file.name}</span>
            </div>
          </FileUploaderItem>
        ))}
      </FileUploaderContent>
    </FileUploader>
  )
}
